export default __webpack_public_path__ + "static/media/kappa-sigma-mu-logo.0283b668.svg";